import React from "react";
import { NodeProps, Handle, Position } from "reactflow";
import { KloudMDNodeStyled } from "../KloudMDNode.styled";

import KloudMDNodeHeader from "../../KloudMDNodeHeader";

const KloudMDInputNode = ({ id, data, selected, isConnectable }: NodeProps) => {
    return (
        <KloudMDNodeStyled selected={selected} isValid={data?.isValid}>
            <div className="block-container">
                <KloudMDNodeHeader id={id} data={data} />
            </div>
            <Handle type="source" position={Position.Bottom} isConnectable={isConnectable} />
        </KloudMDNodeStyled>
    );
};

KloudMDInputNode.displayName = "KloudMDInputNode";

export default React.memo(KloudMDInputNode);
